import React, { useState } from 'react';
import './App.css';
import VendorManagement from './VendorManagement';
import OrdersTable from './OrdersTable';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import { FaCar, FaHome, FaClipboardList, FaStore } from 'react-icons/fa';

function App() {
  const [activeTab, setActiveTab] = useState('home');

  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
          <div className="logo" onClick={() => setActiveTab('home')} style={{ cursor: 'pointer' }}>
            <FaCar className="logo-icon" />
            <h1>SPARE PARTS</h1>
          </div>
          <nav className="header-nav">
            <button 
              className={activeTab === 'home' ? 'nav-btn active' : 'nav-btn'}
              onClick={() => setActiveTab('home')}
            >
              <FaHome /> Home
            </button>
            <button 
              className={activeTab === 'orders' ? 'nav-btn active' : 'nav-btn'}
              onClick={() => setActiveTab('orders')}
            >
              <FaClipboardList /> Orders
            </button>
            <button 
              className={activeTab === 'vendors' ? 'nav-btn active' : 'nav-btn'}
              onClick={() => setActiveTab('vendors')}
            >
              <FaStore /> Vendors
            </button>
          </nav>
        </div>
      </header>

      <main className="main-content">
        {activeTab === 'home' && <HomePage />}
        {activeTab === 'vendors' && <VendorManagement />}
        {activeTab === 'orders' && <OrdersTable />}
      </main>

      <Footer />
    </div>
  );
}

export default App;
